import { createAction } from '@reduxjs/toolkit';
import { getPayloadCreator } from 'app-components/flux/core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { HousingSelectionType } from './housingSelectionTypes';

const housingSelectionPayload = getPayloadCreator<string>();
const housingSelectionPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<HousingSelectionType>>();

export const getAutocompleteHousingSelection = createAction('GET_HOUSINGSELECTION_AC', housingSelectionPayload);
export const getAutocompleteHousingSelectionSuccess = createAction(
  'GET_HOUSINGSELECTION_AC_SUCCESS',
  housingSelectionPayloadCreator,
);
export const getAutocompleteHousingSelectionFailure = createAction('GET_HOUSINGSELECTION_AC_FAILURE');
